import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Navbar";
import UserProfile from "../../components/Profile/UserProfile";

function UserProfilePage() {
  return (
    <div>
      <Header />
      <div className="devider"></div>
      <UserProfile />
      <Footer />
    </div>
  );
}

export default UserProfilePage;
